import { render, staticRenderFns } from "./FormJurnal.vue?vue&type=template&id=14033a10&"
import script from "./FormJurnal.vue?vue&type=script&lang=js&"
export * from "./FormJurnal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports